/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Toolbox Icon component.
 */
export const SideNavToolBoxIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize}
      height={iconSize} fill="none">
      <path stroke={iconColor}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M17 8.5V5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v3.5m10 0h5a1 1 0 0 1 1 1v5.25M17 8.5H7m0 0H2a1 1 0 0 0-1 1v5.25m0 0V20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-5.25m-22 0h22m-5-1.25V16M6 13.5V16"/>
    </svg>
  );
};
